import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ServiceCategory } from '../db/models/categories';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  // private baseUrl = 'https://localhost:44352/api/serviceCategory/';
  private baseUrl = 'https://api.trepezserver.com/api/serviceCategory/';

constructor(private http: HttpClient) { }

getAllServiceCategories(): Observable<ServiceCategory[]> {
  return this.http.get<ServiceCategory[]>(this.baseUrl + 'categories')
}


}
